module.exports = __webpack_public_path__ + "static/media/7.c8b0f52d.jpg";